/**
 * Checks whether the provided input is a string or not, serving as a type guard.
 * @param input string
 * @returns boolean
 */
export const isStringUtil = (input) => typeof input === "string";
export default isStringUtil;
